import React, { useMemo } from 'react'
import { Typography, Empty } from 'antd'
import { useModel } from 'umi'
import { AntdBaseTable } from '@/components/AntdBaseTable'
import { createAPI } from '@/utils/modal'
import BreakPriceDetailModal from '../BreakPriceDetailModal'

import styles from './index.less'

const EmptyContent = () => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />

const MyTable = () => {
    const { list, loading, pagination, query } = useModel('useBreakPriceDrawer')

    const columns = useMemo(
        () => [
            {
                title: '序号',
                code: 'index',
                align: 'center',
                width: 48,
                render: (_, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1
            },
            {
                title: '商品名称',
                code: 'skuName',
                width: 218,
                render: _ => {
                    return <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>{_}</Typography.Paragraph>
                }
            },
            {
                title: '商品编码',
                code: 'skuId',
                width: 120,
                render: _ => <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>{_}</Typography.Paragraph>
            },
            {
                title: '最低分销控价',
                code: 'regulatePrice',
                align: 'center',
                width: 120,
                render: (_, record) => {
                    return (
                        <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>
                            {record.regulatePriceMin === record.regulatePriceMax
                                ? record.regulatePriceMax
                                : [record.regulatePriceMin, record.regulatePriceMax].join('~')}
                        </Typography.Paragraph>
                    )
                }
            },
            {
                title: '买家实付',
                code: 'paidAmount',
                align: 'center',
                width: 120,
                render: (_, record) => {
                    return (
                        <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }}>
                            {record.paidAmountMin === record.paidAmountMax
                                ? record.paidAmountMax
                                : [record.paidAmountMin, record.paidAmountMax].join('~')}
                        </Typography.Paragraph>
                    )
                }
            },
            {
                title: '破价金额',
                code: 'breakPrice',
                align: 'center',
                render: (_, record) => {
                    return (
                        <Typography.Paragraph ellipsis={{ rows: 2, tooltip: true }} style={{ color: '#f53f3f' }}>
                            {record.breakPriceMin === record.breakPriceMax
                                ? record.breakPriceMax
                                : [record.breakPriceMin, record.breakPriceMax].join('~')}
                        </Typography.Paragraph>
                    )
                }
            },
            {
                title: '破价订单数',
                code: 'orderCnt',
                align: 'center',
                width: 120,
                render: (_, record) => {
                    return (
                        <div className={styles.count}>
                            {_}&nbsp;
                            <a
                                onClick={() => {
                                    createAPI(BreakPriceDetailModal, {
                                        skuId: record.skuId,
                                        co: query.co,
                                        day: query.day,
                                        skuName: record.skuName
                                    })
                                }}>
                                查看
                            </a>
                        </div>
                    )
                }
            }
        ],
        [pagination, query]
    )

    return (
        <AntdBaseTable
            primaryKey="skuId"
            className={styles.table}
            dataSource={list}
            columns={columns}
            useVirtual={false}
            useOuterBorder
            isLoading={loading}
            components={{ EmptyContent }}
            stickyTop={112}
            emptyCellHeight={400}
        />
    )
}

export default MyTable
